<template>
  <div class="remaining-parking-space-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('remainingParkingSpace.page.title')" :subtitle="$t('remainingParkingSpace.page.subtitle')">
      <template #extra>
        <el-button type="primary" icon="el-icon-refresh" @click="handleRefresh">
          {{ $t('remainingParkingSpace.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (3)(4) Toolbar + DataTable -->
    <div class="ds-panel">
      <ds-toolbar :total="tableData.length" :density="density" :show-column-setting="false"
        :show-refresh="true" @update:density="density = $event" @refresh="getData">
        <template #left>
          <span class="ds-panel__title">{{ $t('remainingParkingSpace.title') }}</span>
        </template>
      </ds-toolbar>

      <ds-data-table :data="tableData" :loading="loading" :error="hasError" :error-message="errorMessage"
        :density="density" border stripe :empty-description="$t('remainingParkingSpace.page.empty')" @retry="getData">
        <el-table-column prop="total" :label="$t('remainingParkingSpace.total')" align="center" min-width="160">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.total }} {{ $t('remainingParkingSpace.unit') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="freeCount" :label="$t('remainingParkingSpace.freeCount')" align="center" min-width="160">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.freeCount }} {{ $t('remainingParkingSpace.unit') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('remainingParkingSpace.createTime')" align="center" min-width="180">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.createTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('remainingParkingSpace.operation')" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleRefresh(scope.row)">
              {{ $t('remainingParkingSpace.refresh') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>
  </div>
</template>

<script>
import { getRemainingParkingSpace } from '@/api/car/remainingParkingSpaceApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'RemainingParkingSpaceList',
  components: {
    DsPageHeader,
    DsToolbar,
    DsDataTable
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      tableData: [
        {
          total: 0,
          freeCount: 0,
          createTime: this.formatDateTime(new Date().getTime())
        }
      ],
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.getData()
  },
  methods: {
    formatDateTime(timestamp) {
      const date = new Date(timestamp)
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`
    },
    async getData() {
      this.loading = true
      this.hasError = false
      try {
        const params = {
          communityId: this.communityId,
          iotApiCode: 'getFreeParkingSpaceBmoImpl'
        }

        const res = await getRemainingParkingSpace(params)
        if (res.code === 0) {
          this.tableData = [{
            total: res.data.total,
            freeCount: res.data.freeCount,
            createTime: this.formatDateTime(new Date().getTime())
          }]
        } else {
          this.hasError = true
          this.errorMessage = res.msg || this.$t('remainingParkingSpace.fetchError')
          this.$message.error(this.errorMessage)
        }
      } catch (error) {
        this.hasError = true
        this.errorMessage = this.$t('remainingParkingSpace.fetchError')
        this.$message.error(this.$t('remainingParkingSpace.fetchError'))
        console.error('Error fetching remaining parking space:', error)
      } finally {
        this.loading = false
      }
    },
    handleRefresh() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.remaining-parking-space-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
</style>
